import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import ImageIcon from '@quintoandar/cozy-icons/Image';
import Box from '@quintoandar/cozy-core/Box';
import FeedbackBlock from '@quintoandar/cozy-core/FeedbackBlock';
import { LoadingPage } from 'components/LoadingPage';
import RetryFeedback from 'components/RetryFeedback';

import Timeline from 'components/Timeline';
import { fetchStartedPhotoSessionsAction } from './actions';
import {
  makeSelectStartedPhotoSessions,
  makeSelectHasFetchedStartedPhotoSessions,
  makeSelectShowStartedListError,
} from './selectors';
import { buildPhotoSessionItems } from './photoSessionItemsBuilder';
import messages from './messages';

export const StartedPhotoSessions = ({
  photoSessions,
  fetchStartedPhotoSessions,
  intl,
  hasFetchedStartedPhotoSessions,
  showListError,
}) => {
  /* istanbul ignore next */
  useEffect(() => {
    fetchStartedPhotoSessions();
  }, []);
  if (!hasFetchedStartedPhotoSessions) {
    return <LoadingPage />;
  }

  if (photoSessions.length === 0) {
    if (showListError) {
      return (
        <RetryFeedback
          title={messages.startedPhotoSessionsError}
          subtitle={messages.listErrorSubtitle}
          onRetry={fetchStartedPhotoSessions}
        />
      );
    }

    return (
      <Box mt={4}>
        <FeedbackBlock
          kind="empty-state"
          icon={ImageIcon}
          subtitle={messages.startedPhotoSessionsEmptyStateSubTitle}
          title={messages.startedPhotoSessionsEmptyStateTitle}
          showButton={false}
        />
      </Box>
    );
  }

  const startedPhotoSessions = buildPhotoSessionItems({ photoSessions, intl });

  return <Timeline scheduledItems={startedPhotoSessions} />;
};

const mapStateToProps = createStructuredSelector({
  photoSessions: makeSelectStartedPhotoSessions(),
  hasFetchedStartedPhotoSessions: makeSelectHasFetchedStartedPhotoSessions(),
  showListError: makeSelectShowStartedListError(),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchStartedPhotoSessions: () => dispatch(fetchStartedPhotoSessionsAction()),
});

StartedPhotoSessions.propTypes = {
  photoSessions: PropTypes.array,
  hasFetchedStartedPhotoSessions: PropTypes.bool,
  showListError: PropTypes.bool,
  fetchStartedPhotoSessions: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

StartedPhotoSessions.defaultProps = {
  photoSessions: [],
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(StartedPhotoSessions);
